export const POST_LOGIN_INFO = 'POST_LOGIN_INFO'
export const LOG_OUT = 'LOG_OUT'
export const POST_SIGN_UP ='POST_SIGN_UP'
export const INFO_USER_PROFILE='INFO_USER_PROFILE'